import styled from "@emotion/styled";
import { BLUE_LIGHT, OLD_BLUE } from "src/constants/colors";

interface TotalCountBadgeProps {
  backgroundColor?: string;
}

export const TotalCountBadge = styled.div<TotalCountBadgeProps>`
  background-color: ${(props) => props.backgroundColor || BLUE_LIGHT};
  border-radius: 5px;
  color: ${OLD_BLUE};
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 9px;
  font-weight: 600;
  padding: 4px;
  max-height: 15px;
`;
